import { LodgingFormDataState, LodgingFormDataActionTypes, READ_LODGING_FORM_DATA_REQUEST, READ_LODGING_FORM_DATA_SUCCESS, READ_LODGING_FORM_DATA_FAILURE } from "store/reducers/lodgingOption/getFormData/types";

const defaultState: LodgingFormDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function formData(state = defaultState, action: LodgingFormDataActionTypes): LodgingFormDataState {
  switch (action.type) {
    case READ_LODGING_FORM_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_LODGING_FORM_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_LODGING_FORM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};